import { IdentityProvider, PatchSSOSettings } from '@localstack/types';

export type MetadataType = 'MetadataURL' | 'MetadataFile';

/**
 * The identity provider as the form holds it.
 *
 * `MetadataFile` is a `File` while an upload is pending and the XML string Cognito returned
 * otherwise, which the API type cannot express since it only ever sends or receives the string.
 */
export type IdpFormValues = Omit<IdentityProvider, 'MetadataFile'> & {
  MetadataFile?: File | string;
};

export type IdpFormData = {
  idp: IdpFormValues;
  sso_settings: { [k: string]: PatchSSOSettings };
};

export type SubscriptionGroupEntry = {
  id: string;
  name: string;
  group: string;
  created: number;
};

export const IDP_SCIM_SKELETON_HEIGHT = 132;
export const IDP_SKELETON_HEIGHT = 65;
